import { createContext } from 'react';

type EmbeddedWebpageContextValues = {
  sendMessage: (payload: unknown) => void;
};

const DEFAULT_VALUES: EmbeddedWebpageContextValues = {
  sendMessage: (payload: unknown) => {
    console.warn('sendMessage method not set', payload);
  }
};

export const EmbeddedWebpageContext =
  createContext<EmbeddedWebpageContextValues>(DEFAULT_VALUES);
